import Vue from "vue";
import App from "./App.vue";
import sign from "../../utils/sign";

Vue.config.productionTip = false;

sign.initWsgsigSign()

// passportAppId=121434&passportRole=2451
async function init() {
  new Vue({
    render: (h) => h(App),
  }).$mount("#app");
}

if (document.referrer.indexOf("https://getsimnum.caict.ac.cn") > -1) {
  init();
}
